export default __webpack_public_path__ + "alberta-fab-share.b5b10f9defab7cf0b8f6.svg";